import React, { useEffect, useState } from "react";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import { RxCross2 } from "react-icons/rx";

function CartItems({ nextProcess ,setCartData,setTotalPrice }) {
  const [cartItems, setCartItems] = useState(
    JSON.parse(localStorage.getItem("cartItems")) || []
  );
  const [cartTotalPrice, setCartTotalPrice] = useState();


  useEffect(() => {
    let totalPrice = 0;
    cartItems.forEach((item) => {
      const pricePerUnit = parseFloat(item.variants.nodes[0].price.amount);
      const totalValue = pricePerUnit * item.selectedQuantity;
      totalPrice += totalValue || 0;
    });
    setCartTotalPrice(totalPrice);
    localStorage.setItem("cartItems", JSON.stringify(cartItems));
  }, [cartItems]);

  const handleQuantityChange = (index, newQuantity, product) => {
    const updatedCartItems = [...cartItems];
    updatedCartItems[index].selectedQuantity = newQuantity;
    const pricePerUnit = parseFloat(product.variants.nodes[0].price.amount);
    const totalValue = pricePerUnit * newQuantity;
    updatedCartItems[index].totalValue = totalValue;
    setCartItems(updatedCartItems);
  };

  const removeItemFromCart = (index) => {
    const updatedCartItems = [...cartItems];
    updatedCartItems.splice(index, 1);
    setCartItems(updatedCartItems);
  };

  useEffect(() => {
    setCartData(cartItems)
    setTotalPrice(cartTotalPrice)
  }, [cartItems,cartTotalPrice])
  
  return (
    <div className="flex flex-col justify-start items-center bg-white shadow-md w-full">
      <div className="flex justify-between items-center p-3 border-b w-full heading">
        <h3 className="font-primaryFont font-semibold text-lg uppercase tracking-wider">
          Selected Products
        </h3>
      </div>
      <div className="cart-item-container overflow-y-scroll">
        <div className="p-4 cart-card-container">
          {cartItems.map((product, index) => (
            <div
              key={product.id}
              className="flex justify-between items-start gap-2 py-2 border-b w-full cart-card"
            >
              <div className="p-2 w-[25%] md:w-[20%] lg:w-[10%] image-container">
                <img src={product.featuredImage.url} alt={product.title} />
              </div>
              <div className="relative flex flex-col justify-start items-start pt-2 w-[70%] text-sm detail-container">
                <div className="flex justify-between items-center mb-2 w-full heading-container">
                  <h2 className="tracking-wider">
                    {product.title.split(" - ")[0]}
                  </h2>
                  <button
                    className="ml-auto focus:outline-none"
                    onClick={() =>  removeItemFromCart(index)}
                  >
                    <RxCross2 className="text-2xl text-gray-500 hover:text-gray-700" />
                  </button>
                </div>

                {/* <p className="text-xs">
                  <span className="font-semibold">Color:</span>
                  {
                    product.options?.find((option) => option.name === "Color")
                      .values[0]
                  }
                </p> */}
                 <p className="text-xs">
                    <span className="font-semibold">Color:</span>{" "}
                    {product.options &&
                    product.options.find((option) => option.name === "Color")
                      ? product.options.find(
                          (option) => option.name === "Color"
                        ).values[0]
                      : "N/A"}
                  </p>
                <p className="text-xs">
                  <span className="font-semibold">Size:</span>
                  {product.selectedSize}
                </p>
                <p className="text-xs">
                  <span className="font-semibold">Quantity:</span>
                  {product.selectedQuantity}
                </p>
                <div className="relative flex justify-between items-center mt-2 w-full quantity-total-container">
                  <div className="relative flex justify-center items-center border quantity-container">
                    <span
                      className="hover:bg-black p-2 hover:text-white"
                      onClick={(event) => {
                        event.stopPropagation();
                        handleQuantityChange(
                          index,
                          product.selectedQuantity - 1 > 0
                            ? product.selectedQuantity - 1
                            : 1,
                          product
                        );
                      }}
                    >
                      <AiOutlineMinus />
                    </span>
                    <input
                      type="text"
                      disabled
                      min="1"
                      value={product.selectedQuantity}
                      className="bg-white w-5 text-center"
                      placeholder="1"
                    />
                    <span
                      className="hover:bg-black p-2 hover:text-white"
                      onClick={(event) => {
                        event.stopPropagation();
                        handleQuantityChange(
                          index,
                          product.selectedQuantity + 1,
                          product
                        );
                      }}
                    >
                      <AiOutlinePlus />
                    </span>
                  </div>
                  <div className="text-right w-full font-secondaryFont total-container">
                    <span className="font-semibold capitalize tracking-widest">
                      Rs.
                      {product.variants.nodes[0].price.amount *
                        product.selectedQuantity}
                      {/* Rs.{product.totalValue} */}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="flex flex-col justify-between items-center gap-4 p-6 w-full checkout-container">
        <div className="flex justify-between items-center w-full font-secondaryFont text-sm uppercase total-container">
          <span className="font-semibold">subtotal</span>
          <span className="font-bold capitalizze">Rs. {cartTotalPrice}</span>
        </div>
        <div className="flex flex-col justify-center items-center gap-2 order-btn-container font-primaryFont">
          <p className="text-[10px] text-center text-primary">
            Shipping, taxes, and discount are Included.
          </p>

          <button
            onClick={() => nextProcess()}
            className="bg-black hover:bg-primary hover:shadow-md py-2 w-full font-semibold text-sm text-white uppercase tracking-wider"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

export default CartItems;
